<template>
  <v-snackbar
    :model-value="show"
    :color="color"
    location="top"
    timeout="5000"
    elevation="2"
    :z-index="10000"
  >
     <div class="text-center">{{ message }}</div>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: "",
      color: "",
    };
  },

  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "snackbar/showMessage") {
        this.message = state.snackbar.content;
        this.color = state.snackbar.color;
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
        });
      }
    });
  },
};
</script>